import { LinearProgress, Stack } from "@mui/material"
import { useEffect, useState } from "react"
import { uniqueId } from "library/database/split-id.mjs"
import { Loader } from "lib/@components/Loader"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { refreshId } from "lib/graphql/api"
import { StatusMessages } from "routes/asset-register/plugins/asset-mapping/status-messages"
import { busyStore } from "routes/asset-register/plugins/asset-mapping/busy-store"
import { Mobiliser } from "routes/asset-register/plugins/asset-mapping/mobiliser"
import { getRegisterProgress } from "routes/asset-register/plugins/asset-mapping/controller/get-register-progress"

export function LegacyMappingProgress() {
    const { target } = useBoundContext()
    const [busy, setBusy] = useState(busyStore[uniqueId(target._id)])
    const [progress, setProgress] = useState(0)
    const registerProgress = getRegisterProgress.useResults(refreshId(target._id))

    useEffect(trackProgress, [registerProgress, busy])

    return (
        <>
            <If value={busy}>
                <Stack data-cy="refining-types-busy" sx={{ mt: 2 }} spacing={2}>
                    <LinearProgress color="primary" variant="determinate" value={progress} />
                    <Loader caption="Processing types..." inline color="primary" />
                </Stack>
                <Else>
                    <Stack spacing={1}>
                        <Mobiliser $lazy />
                    </Stack>
                </Else>
            </If>
            <StatusMessages />
        </>
    )

    function trackProgress() {
        const finished =
            !registerProgress || registerProgress.lastBlockSize < 0 || registerProgress.message === "FINISHED"
        if (finished) {
            setProgress(0)
            setBusy(false)
            return
        }
        setBusy(true)
        setProgress((100 * (registerProgress.total - registerProgress.remaining)) / registerProgress.total)
    }
}
